export default {
  ATTR: "attr",
  ATTR_ITEM: "attrItem"
};



// WEBPACK FOOTER //
// ./src/components/SetupAttr/ItemTypes.js